import { useTranslation } from '../../hooks/translation';
import AppContainer from '../AppContainer/AppContainer';
import AppImage from '../AppImage';
import AppText from '../AppText/AppText';

import styles from './AboutUs.module.scss';

export default function AboutUs() {
  const { translate } = useTranslation();

  return (
    <section className={styles.AboutUs}>
      <AppContainer>
        <div className={styles.AboutUs__Inner}>
          <div className={styles.AboutUs__Left}>
            <div className={styles.AboutUs__Left_Title}>
              <h3 className={styles.AboutUs__Title}>{translate('aboutus_title')}</h3>
            </div>
            <div className={styles.AboutUs__Left_Desc}>
              <AppText>{translate('aboutus_text')}</AppText>
            </div>
          </div>
          <div className={styles.AboutUs__Right}>
            <figure>
              <AppImage src='/images/first_half.svg' />
            </figure>
            <figure>
              <AppImage src='/images/second_half.svg' />
            </figure>
          </div>
        </div>
      </AppContainer>
    </section>
  );
}
